import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import {
    postTerrainPreplotDataApi,
    getTerrainPreplotListDataApi,
    postSaveTerrainPreplotDataApi,
    deletTerrainPreplotTableDataApi
} from 'api'
import { BoundarySlice } from 'redux/reducers'

const initialState = {
    dictData: null, // 树形多选框字典
    locationTreeCheckDictData: null, // 已选中树形多选框
    locationData: null, // 场所信息列表
    paginatedData: null, // 分页数据
    idData: null, // 单条回显数据
    pageNum: 1, // 初始分页数
}

/* 获取所有 Preplot 列表 */
export const getTerrainPreplotListDataAction = createAsyncThunk(
    'TerrainPreplotSlice/getTerrainPreplotListDataAction',
    async (projectId, thunkAPI) => {
        try {
            const { data } = await getTerrainPreplotListDataApi(projectId)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* 新增数据 */
export const postTerrainPreplotDataAction = createAsyncThunk(
    'TerrainPreplotSlice/postTerrainPreplotDataAction',
    async ({ params, file }, thunkAPI) => {
        try {
            const data = await postTerrainPreplotDataApi(params, file)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* 删除 Preplot 表格单条数据 */
export const deletTerrainPreplotTableDataAction = createAsyncThunk(
    'TerrainPreplotSlice/deletTerrainPreplotTableDataAction',
    async (id, thunkAPI) => {
        try {
            const { data } = await deletTerrainPreplotTableDataApi(id)
            return data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* 保存  */
export const postTerrainPreplotIdDataAction = createAsyncThunk('TerrainPreplotSlice/postTerrainPreplotIdDataAction', async (id, thunkAPI) => {
    try {
        const { data } = await postSaveTerrainPreplotDataApi(id)
        return data
    } catch (error) {
        thunkAPI.dispatch(BoundarySlice.actions.addError(error))
    }
})

export const TerrainPreplotSlice = createSlice({
    name: 'TerrainPreplotSlice',
    initialState,
    reducers: {
        changepPageNum: (state, action) => {
            state.pageNum = action.payload
        },
    },
    extraReducers: {
        /* 获取所有地形文件 */
        [getTerrainPreplotListDataAction.fulfilled.type]: (state, action) => {
            state.paginatedData = action.payload
        },
    },
})
